export default __webpack_public_path__ + "static/media/GDYY5nKHVPk-1717761614793.7e395f41.jpg";